/* eslint-disable prefer-object-spread */
import { createReducer } from 'reduxsauce';
import Types from '../Actions/Types';

export const INITIAL_STATE = {
	fetchingUserInfo: false,
	user: {}
};

const requestUserInfo = state => {
	return Object.assign({}, state, {
		fetchingUserInfo: true
	});
};

const receiveUserInfo = (state, action) => {
	return Object.assign({}, state, {
		fetchingUserInfo: false,
		user: Object.assign({}, action.response.data)
	});
};

const receiveUserInfoFail = state => {
	return Object.assign({}, state, {
		fetchingUserInfo: false,
		user: Object.assign({})
	});
};

/**
 * Called by the saga in the finally block to ensure that in all cases the
 * fetching state for the call is set back to false to avoid infinite loader
 * and the ability to display both loaders and "sorry no data" messages.
 * @param {object} state
 * @param {object} action
 */
const handleLoader = (state, action) => {
	return Object.assign({}, state, {
		[action.fetchName]: false
	});
};

// map our types to our handlers
const ACTION_HANDLERS = {
	[Types.API_CIBC_SINGLE_REQUEST_USER_INFO]: requestUserInfo,
	[Types.API_CIBC_RECEIVE_USER_INFO]: receiveUserInfo,
	[Types.API_CIBC_RECEIVE_USER_INFO_FAIL]: receiveUserInfoFail,
	[Types.API_CIBC_HANDLE_USER_INFO]: handleLoader
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
